import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import Container from 'components/Container';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'Uf';
  const defaultValues = {
    sigla: '',
    estado: '',
    pais_id: null,
    codigo_ibge: '',
    icms_interno: '',
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { drops, getDrops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => {
        navigate(-1);
        getDrops([rotina]);
      },
    });

  return (
    <Container>
      <Header titulo={(Boolean(state) ? 'Editar' : 'Cadastrar') + ' UF'} />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Input name="sigla" control={control} label="Sigla" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input name="estado" control={control} label="Estado" />
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              name="pais_id"
              control={control}
              label="País"
              options={drops?.Pais}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="codigo_ibge"
              control={control}
              label="Código IBGE"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              name="icms_interno"
              control={control}
              label="ICMS Interno"
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
